import { z } from 'zod';
import { UserSchema } from '../../../../entities/user/user.schema';
/**
 * Generate Tenant User Activation Link Request Schema
 * POST /api/v2/tenants/:tenantId/users/:userId/activation-link
 *
 * No request body needed - IDs come from URL params
 */ export const GenerateTenantUserActivationLinkRequestSchema = z.object({});
/**
 * Generate Tenant User Activation Link Response Schema
 *
 * Mints a fresh activation token (invalidating any previously emailed one),
 * sets the user to 'pending', and returns the full link for manual delivery.
 * The raw token is never persisted, so the original emailed link cannot be reused.
 */ export const GenerateTenantUserActivationLinkResponseSchema = z.object({
    data: z.object({
        activationLink: z.url(),
        user: UserSchema
    })
});

//# sourceMappingURL=generate-tenant-user-activation-link.schema.js.map